export interface ContentInlineTemplateArgs {
  id: string;
  displayName: string;
}

export const formatContentInlineTemplateString = ({ id, displayName }: ContentInlineTemplateArgs): string =>
  `{{content.${id}.link:${displayName}}}`;
